<template src="./user-management.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import { hasUserManageClaim, hasUserReviewClaim } from '@/router/auth.js'

export default {
  components: {
    ContextPage,
    Tabulator
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      data: [],
      UserStatus: {
        ACTIVE: 1,
        INACTIVE: 2,
        REVOKED: 3,
        DISABLED: 4
      },
      help: {
        list: Vue.$helpConfig.userList
      },
      loader: false,
      loading: false,
      pageLoader: false,
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root + '/' + Vue.$apiConfig.pagedUsersGet,
        columns: [
          { title: '', field: 'id', visible: false, headerSort: false },
          {
            title: this.$t('organizationAdministration.budgetUserId'),
            field: 'organizationId',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            visible: hasUserReviewClaim()
          },
          {
            title: this.$t('userAdministration.organizationName'),
            field: 'organizationName',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            visible: hasUserReviewClaim()
          },
          {
            title: this.$t('userAdministration.name'),
            field: 'name',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('userAdministration.userLogin'),
            field: 'login',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('userAdministration.email'),
            field: 'email',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('userAdministration.userRoleName'),
            field: 'roleName',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('userAdministration.userStatus'),
            hozAlign: 'center',
            field: 'status',
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            formatter: (cell) => {
              const status = cell.getValue()
              if (status === this.UserStatus.ACTIVE) {
                return this.successLabel(this.$t('userStatus.' + status))
              } else if (status === this.UserStatus.INACTIVE) {
                return this.inactiveLabel(this.$t('userStatus.' + status))
              }

              return this.errorLabel(this.$t('userStatus.' + status))
            },
            headerFilterParams: {
              values: [
                { text: this.$t('userStatus.1'), value: 1 },
                { text: this.$t('userStatus.2'), value: 2 },
                { text: this.$t('userStatus.3'), value: 3 },
                { text: this.$t('userStatus.4'), value: 4 }
              ]
            }
          },
          {
            title: this.$t('userAdministration.lastLoginDate'),
            hozAlign: 'center',
            field: 'lastLoginDate',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vDateRange,
            headerFilterLiveFilter: false,
            headerFilterParams: { isRange: true },
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatDate(cell.getValue()) : '-'
            }
          }
        ],
        rowClick: (e, row) => {
          const administrationURL = '/administration/user/' + row.getData().login
          this.handleRowClickNavigation(e, administrationURL)
        }
      }
    }
  },
  computed: {
    displayUserCreateButton () {
      return hasUserManageClaim()
    }
  }
}
</script>
<style>
.status-active-span {
   background-color: #4caf50;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-inactive-span {
   background-color: #ECEFF1;
   color: #000;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-revoked-span {
   background-color: #ff5252;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

</style>
